import { InventorySummaryListFilters } from "@/models/api/barcodeSystem/inventory/summary";
import { InventoryItemListFilters } from "@/models/api/barcodeSystem/inventory/inventoryItems";
import { PalletListFilters } from "@/models/api/barcodeSystem/inventory/pallets";
import { BulkInventoryItemListFilters } from "@/models/api/barcodeSystem/inventory/bulkInventoryItems";

export function defaultSummaryFilters(): InventorySummaryListFilters {
  return {
    type: null,
    id: null,
    facilityCodes: null,
    warehouseLocationId: null,
    companyIds: null,
    orderId: null,
    orderNumber: null,
    crn: null,
    manufacturerCodes: null,
    modelNumber: null,
    itemType: null,
    itemDescription: null,
    sku: null,
    itemScan: null,
    serialNumber: null,
    poNumber: null,
    quantity: null,
    returned: null,
    returnReason: null,
    damaged: null,
    damageCode: null,
    statuses: null,
    receivedDate: null,
    loadedDate: null,
    deliveredDate: null,
    inventoryItemId: null,
    bulkItemId: null,
    palletId: null
    } as InventorySummaryListFilters;
}

export function defaultItemFilters(): InventoryItemListFilters {
  return {
    id: null,
    facilityCodes: null,
    warehouseLocationId: null,
    companyIds: null,
    orderId: null,
    orderNumber: null,
    crn: null,
    manufacturerCodes: null,
    modelNumber: null,
    itemType: null,
    itemDescription: null,
    sku: null,
    itemScan: null,
    serialNumber: null,
    poNumber: null,
    quantity: null,
    returned: null,
    returnReason: null,
    isDamaged: null,
    damageCode: null,
    shrinkage: null,
    statuses: null,
    receivedDate: null,
    loadedDate: null,
    deliveredDate: null,
    palletId: null,
    isOpen: null,
    isAvailable: null,
    canBeAddedToOrder: null
    } as InventoryItemListFilters;
}

export function defaultLinkItemFilters(): InventoryItemListFilters {
  return {
    id: null,
    facilityCodes: null,
    warehouseLocationId: null,
    companyIds: null,
    orderId: null,
    orderNumber: null,
    crn: null,
    manufacturerCodes: null,
    modelNumber: null,
    itemType: null,
    itemDescription: null,
    sku: null,
    itemScan: null,
    serialNumber: null,
    poNumber: null,
    quantity: null,
    returned: null,
    returnReason: null,
    isDamaged: null,
    damageCode: null,
    shrinkage: null,
    statuses: null,
    receivedDate: null,
    loadedDate: null,
    deliveredDate: null,
    palletId: null,
    isOpen: null,
    isAvailable: true,
    canBeAddedToOrder: true
    } as InventoryItemListFilters;
}

export function defaultPalletFilters(): PalletListFilters {
  return {
    id: null,
    palletNumber: null,
    palletGroupId: null,
    facilityCodes: null,
    warehouseLocationId: null,
    companyIds: null,
    orderId: null,
    orderNumber: null,
    crn: null,
    manufacturerCodes: null,
    statuses: null,
    createdDate: null,
    isNoScanPallet: null,
    hasItems: null
    } as PalletListFilters;
}

export function defaultBulkFilters(): BulkInventoryItemListFilters {
  return {
    id: null,
    facilityCodes: null,
    warehouseLocationId: null,
    companyIds: null,
    manufacturerCodes: null,
    modelNumber: null,
    itemType: null,
    itemDescription: null,
    sku: null,
    quantity: null
    } as BulkInventoryItemListFilters;
}

